import { render } from "./RecursoPeces.vue?vue&type=template&id=f7269526&scoped=true"
import script from "./RecursoPeces.vue?vue&type=script&lang=js"
export * from "./RecursoPeces.vue?vue&type=script&lang=js"

import "./RecursoPeces.vue?vue&type=style&index=0&id=f7269526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7269526"]])

export default __exports__